import { ActionType } from "@sp-crm/core";
import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";
import { useFeature, useIsAllowedInWholeTenant } from "store/selectors/hooks";

export const ManageIntegrationsNav: React.FC<unknown> = () => {
    const isTwilioEnabled = useFeature("twilioIntegration");
    const isWebhooksEnabled = useFeature("webhooks");
    const isPlacementEnabled = useFeature("placement");
    const wholeTenantAccess = useIsAllowedInWholeTenant(ActionType.ManageIntegrations);

    return (
        <TertiarynavMenu>
            {wholeTenantAccess && (
                <TertiarynavMenuItem to="/settings/integrations/accounts">
                    Accounts
                </TertiarynavMenuItem>
            )}
            {isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/quickbooks">
                    QuickBooks
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/mailchimp">
                    Mailchimp
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/constant-contact">
                    Constant Contact
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isTwilioEnabled && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/twilio">
                    Twilio
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isWebhooksEnabled && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/webhooks">
                    Webhooks
                </TertiarynavMenuItem>
            )}
        </TertiarynavMenu>
    );
};
